import { z } from "zod";

export const PhoneNumber = z.object({
    dialCode: z.string().regex(/^\+\d+$/),
    countryCode: z.string().length(2),
    phoneNumber: z.string(),
    parsedPhoneNumber: z.string(),
    isValid: z.boolean(),
});

export type PhoneNumber = z.infer<typeof PhoneNumber>;

export const PhoneNumberCountryCode = PhoneNumber.pick({
    dialCode: true,
    countryCode: true,
});

export type PhoneNumberCountryCode = z.infer<typeof PhoneNumberCountryCode>;
